import { CSSProperties } from "react";
import { greys, colors } from "@clockwise/web-commons/src/styles/color.styles";
export { gradient } from "@clockwise/web-commons/src/styles/color.styles";

export const avatar: CSSProperties = {
  overflow: "visible",
  flexShrink: 0,
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "white",
  fontWeight: 600,
  position: "relative",
};

export const row: CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
};

export const remainder: CSSProperties = {
  ...avatar,
  backgroundColor: greys.blueGrey,
};

export const badge: CSSProperties = {
  position: "absolute",
  backgroundColor: colors.blueCool.standard,
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const responseBadge: CSSProperties = {
  position: "absolute",
  backgroundColor: greys.white,
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 2,
};
